import React from "react";
import {useTranslation} from "react-i18next";
import {PieReportWidget} from "../PieReportWidget/PieReportWidget";

export const OrderTimeStatsWidget = ({data, loading}) => {
    const {t} = useTranslation(["orderTimeStatsWidget"]);
    const orderTimeData = [
        {
            name: t("orderTimeData.preparation", {ns: "orderTimeStatsWidget"}),
            value: data?.averagePreparation,
            color: "#00AFFF"
        },
        {
            name: t("orderTimeData.transfer", {ns: "orderTimeStatsWidget"}),
            value: data?.averageDelivery,
            color: "#5DC6FF"
        }
    ];
    return (
        <PieReportWidget
            data={orderTimeData}
            loading={loading}
            title={
                <h3>
                    {t("avgDeliveryTime", {ns: "orderTimeStatsWidget"})}:{" "}
                    <b>
                        {(data?.averagePreparation + data?.averageDelivery).toFixed(2) || "0"}{" "}
                        {t("units.minute.short", {ns: "common"})}
                    </b>
                </h3>
            }
            unitLabel={t("units.minute.short", {ns: "common"})}
        />
    );
};
